import { ClientHandler } from '../../../types/client-handler';
import type { FormDataOf } from '../../../types/templates';
import { getMacroSacaTuTarjetaHelpers } from '../../../clients/MACRO/saca-tu-tarjeta/helpers';
import { macroSacaTuTarjeta } from '../../../clients/MACRO/saca-tu-tarjeta';

type SacaTuTarjetaFormData = FormDataOf<typeof macroSacaTuTarjeta>;

const helpers = getMacroSacaTuTarjetaHelpers();

export const macroHandler: ClientHandler = {
  applyFieldLogic: (fieldKey, value, formData) => {
    if (formData._creativityType === 'macro-saca-tu-tarjeta') {
      return helpers.applyFieldLogic(fieldKey, value, formData as SacaTuTarjetaFormData);
    }
    return {};
  },

  shouldShowField: (fieldKey, formData, creativityType) => {
    if (creativityType === 'macro-saca-tu-tarjeta') {
      return helpers.shouldShowField(fieldKey, formData as SacaTuTarjetaFormData, creativityType);
    }
    return true;
  },

  validateForm: (formData, baseErrors) => {
    if (formData._creativityType === 'macro-saca-tu-tarjeta') {
      const customErrors = helpers.validateForm(formData as SacaTuTarjetaFormData);
      return { ...baseErrors, ...customErrors };
    }
    return baseErrors;
  },

  getDynamicOptions: (fieldKey, formData, baseOptions) => {
    if (formData._creativityType === 'macro-saca-tu-tarjeta') {
      return helpers.getDynamicOptions(fieldKey, formData as SacaTuTarjetaFormData, baseOptions);
    }
    return undefined;
  },

  getDemoPreviews: (formData, creativityType) => {
    if (creativityType === 'macro-saca-tu-tarjeta') {
      return helpers.getDemoPreviews(formData as SacaTuTarjetaFormData);
    }
    return {};
  },

  getMaxLinesForVariant: (formData, stage, channel, variant) => {
    if (formData._creativityType === 'macro-saca-tu-tarjeta') {
      return helpers.getMaxLinesForVariant(stage, channel, variant);
    }
    return 1;
  },

  getFileNaming: (formData, _resolution) => {
    if (formData._creativityType === 'macro-saca-tu-tarjeta') {
      return helpers.getFileNaming(formData as SacaTuTarjetaFormData);
    }
    return undefined;
  }
};
